import React from 'react';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import logoImage from '../../images/Logo_addox.png';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#0b1224] via-[#0a0d18] to-[#07090f] text-white pt-12 sm:pt-14 md:pt-16 pb-8 sm:pb-10">
      <div className="w-full max-w-none mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
        <div className="flex flex-col min-[1368px]:flex-row min-[1368px]:items-start min-[1368px]:justify-between gap-8 sm:gap-10 md:gap-12 mb-10 sm:mb-12 md:mb-14">
          <div className="max-w-4xl w-full">
            {/* Logo and Brand Section */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-4 mb-6">
              <img 
                src={logoImage} 
                alt="The Adox Logo" 
                className="w-[70px] h-[70px] xs:w-[80px] xs:h-[80px] sm:w-[90px] sm:h-[90px] md:w-[110px] md:h-[110px] lg:w-[130px] lg:h-[130px] object-contain flex-shrink-0"
              />
              <div className="flex flex-col items-start text-left">
                {/* Brand Name */}
                <div className="text-[32px] xs:text-[36px] sm:text-[44px] md:text-[52px] lg:text-[64px] font-heading font-bold leading-none text-left">
                  <span className="text-[#E68A40] tracking-tight">The</span>
                  <span className="text-white tracking-tight">Adox.com</span>
                </div>
                {/* Tagline */}
                <div className="mt-2 sm:mt-2.5">
                  <p className="text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl text-white font-normal tracking-[0.12em] sm:tracking-[0.15em] uppercase">
                    VIRTUAL INTELLIGENCE
                  </p>
                  <div className="w-16 sm:w-20 h-0.5 bg-gradient-to-r from-transparent via-[#E68A40] to-transparent rounded-full mt-2 sm:mt-3"></div>
                </div>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="mt-5 sm:mt-6 flex flex-wrap items-center gap-x-5 sm:gap-x-6 gap-y-3 sm:gap-y-3 text-sm sm:text-base text-white/70">
              <a 
                href="https://www.facebook.com/profile.php?id=61585092957182" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center gap-2 hover:text-[#E68A40] transition-colors whitespace-nowrap min-h-[44px] py-2"
                aria-label="Visit our Facebook page"
              >
                <FaFacebook className="text-base sm:text-lg flex-shrink-0" />
                <span>Facebook</span>
              </a>
              <a 
                href="https://www.instagram.com/theadox.ig/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center gap-2 hover:text-[#E68A40] transition-colors whitespace-nowrap min-h-[44px] py-2"
                aria-label="Visit our Instagram page"
              >
                <FaInstagram className="text-base sm:text-lg flex-shrink-0" />
                <span>Instagram</span>
              </a>
              <a 
                href="https://www.tiktok.com/@theadox.tiktok?is_from_webapp=1&sender_device=pc" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center gap-2 hover:text-[#E68A40] transition-colors whitespace-nowrap min-h-[44px] py-2"
                aria-label="Visit our TikTok page"
              >
                <FaTiktok className="text-base sm:text-lg flex-shrink-0" />
                <span>TikTok</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Full-width divider and copyright */}
      <div className="border-t border-white/10 w-full mt-2"></div>
      <div className="w-full max-w-none mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
        <div className="pt-5 sm:pt-6 text-xs sm:text-sm md:text-base text-white/40 text-center sm:text-left">
          <p>&copy; 2025 TheAdox.com. All Rights Reserved.</p>
          <p className="mt-2 text-xs sm:text-sm text-white/50">
            <a href="/privacy-policy.html" className="hover:text-[#E68A40] underline underline-offset-4">
              Privacy Policy
            </a>
            <span className="mx-2">|</span>
            <a href="/terms.html" className="hover:text-[#E68A40] underline underline-offset-4">
              Terms of Service
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;